{
  "wreck": { "sg": "wreck", "pl": "wrecks" },
  "hull_fragment": { "sg": "hull fragment", "pl": "hull fragments" },
  "life_raft": { "sg": "life raft", "pl": "life rafts" },
  "flight_recorder": { "sg": "flight recorder", "pl": "flight recorders" },
  "logbook": { "sg": "logbook", "pl": "logbooks" },
  "compass": { "sg": "compass", "pl": "compasses" },
  "distress_call": { "sg": "distress call", "pl": "distress calls" },
  "survivor": { "sg": "survivor", "pl": "survivors" },
  "sonar_contact": { "sg": "sonar contact", "pl": "sonar contacts" },
  "anomaly": { "sg": "anomaly", "pl": "anomalies", "an": true },
  "trench": { "sg": "trench", "pl": "trenches" },
  "research_base": { "sg": "research base", "pl": "research bases" },
  "submarine": { "sg": "submarine", "pl": "submarines" },
  "vessel": { "sg": "vessel", "pl": "vessels" },
  "aircraft": { "sg": "aircraft", "pl": "aircraft", "an": true },
  "crew_member": { "sg": "crew member", "pl": "crew members" },
  "clue": { "sg": "clue", "pl": "clues" },
  "storm": { "sg": "storm", "pl": "storms" },
  "current": { "sg": "current", "pl": "currents" },
  "debris_field": { "sg": "debris field", "pl": "debris fields" }
}
